//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

import accordion from '~/mixins/accordion'

export default {
  mixins: [accordion],
  props: {
    product: Object,
    productId: String
  },
  computed: {
    compareDisabled () {
      return !this.$store.getters['compare/canCompareItem'](this.product)
    }
  },
  methods: {
    ...mapMutations({
      addToCart: 'cart/add',
      removeFromCart: 'cart/remove',
      emptyCart: 'cart/emptyList',
      addToCompare: 'compare/add',
      removeFromCompare: 'compare/remove',
      emptyCompare: 'compare/emptyList'
    }),
    isCartItem (product) {
      return this.$store.getters['cart/isCartItem'](product)
    },
    isCompareItem (product) {
      return this.$store.getters['compare/isCompareItem'](product)
    }
  }
}
